module.exports = __webpack_public_path__ + "img/8141a4a.png";